import { FlexTemplateNode, FlexTemplateNodeProps, FlexTemplateRenderer } from 'flex-template-renderer-react';
import * as React from 'react';

import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';

interface FlexTemplate extends FlexTemplateNode {
  childNodes: FlexTemplateNode[];
  options: {
    rfrrId: string;
    linkName: string;
  };
}

export interface IntersectionTrackerProps extends FlexTemplateNodeProps {
  flexTemplateNode: FlexTemplate;
}

export const IntersectionTrackerWrapper: React.FC<IntersectionTrackerProps> = (props: IntersectionTrackerProps) => {
  const { childNodes, options } = props.flexTemplateNode;

  return (
    <IntersectionTracker trackOnce={true} referrerId={options.rfrrId} linkName={options.linkName}>
      {childNodes && <FlexTemplateRenderer template={childNodes} />}
    </IntersectionTracker>
  );
};
